/* Kandes sample pages — kandes.ch (CH samples build, 12 Jul 2026).
 *
 * Self-contained behaviour for the sample buy panel (snippets/kandes-sample-buy.liquid)
 * and the standalone trade verifier (sections/kandes-trade-sample.liquid):
 *   - sample_view / sample_add_to_cart / sample_buy_now_click / trade_sample_verify /
 *     sample_discover_click / sample_showroom_click via the same triple mechanism as
 *     kandes-product-tabs.js (Shopify.analytics.publish + dataLayer + gtag).
 *   - Buy now: AJAX add to the existing basket, then straight to /checkout;
 *     cart-permalink fallback on any failure (also the no-JS path).
 *   - Add to basket: AJAX + inline confirmation with a basket link (the .ch cart icon
 *     is CSS-hidden by design — this link is how sample buyers reach the basket).
 *   - Trade verifier, TWO MODES via form[data-trade-live]:
 *       OFF (default, works against the worker DEPLOYED today): every submission —
 *       Swiss CHE-UID or EU VAT — is captured as a form_type:"message" lead on the
 *       live gateway with a TRADE SAMPLE REQUEST marker. Yulia verifies and replies
 *       with the trade code by email (draft-first rule; no code exists on .ch yet).
 *       ON ("1", flip ONLY after the staged worker patch is deployed AND the
 *       TRADESAMPLECH discount exists): POST {gateway}/trade-sample with
 *       { email, vat, store:"ch" } and reveal the returned code on screen, exactly
 *       like kandes.eu.
 *   - All user-facing strings come from a JSON i18n blob rendered by the Liquid
 *     (script[type="application/json"][data-ksmp-i18n]) so de/fr/it work.
 *
 * NEVER add panel prices or panel buy paths here — kandes.ch panels are quote-only.
 */
(function () {
  'use strict';
  if (window.__kandesSampleInit) return;
  window.__kandesSampleInit = 1;

  function track(name, params) {
    params = params || {};
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, params);
      }
    } catch (e) { /* analytics must never break UX */ }
    try {
      window.dataLayer = window.dataLayer || [];
      var entry = { event: name };
      Object.keys(params).forEach(function (k) { entry[k] = params[k]; });
      window.dataLayer.push(entry);
      if (typeof window.gtag === 'function') { window.gtag('event', name, params); }
    } catch (e) { /* ditto */ }
  }

  function i18n() {
    var tag = document.querySelector('script[type="application/json"][data-ksmp-i18n]');
    if (!tag) return {};
    try { return JSON.parse(tag.textContent); } catch (e) { return {}; }
  }

  function gatewayFor(el) {
    var gw = '';
    var host = el && el.closest('[data-kandes-gateway-fallback]');
    var global = document.querySelector('[data-kandes-gateway]');
    if (global) gw = global.getAttribute('data-kandes-gateway') || '';
    if (!gw && host) gw = host.getAttribute('data-kandes-gateway-fallback') || '';
    return gw.replace(/\/+$/, '');
  }

  /* ---------- sample_view (top of the funnel) ---------- */
  function fireView() {
    var el = document.querySelector('[data-kandes-sample-view]');
    if (!el || el.getAttribute('data-kandes-viewed')) return;
    el.setAttribute('data-kandes-viewed', '1');
    track('sample_view', {
      product: el.getAttribute('data-sample-title') || '',
      sku: el.getAttribute('data-sample-sku') || '',
      /* price/currency deliberately absent while the CHF sample price is gated
         on Hochwert clearance — no CHF number may appear anywhere, including
         data attributes and analytics payloads. */
      price: parseFloat(el.getAttribute('data-sample-price')) || 0,
      currency: el.getAttribute('data-sample-currency') || ''
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fireView);
  } else { fireView(); }

  /* ---------- Buy now / Add to basket (15 Jul: capture-phase + cart-count) ----------
     Capture phase + stopImmediatePropagation so a drawer theme's own cart-link
     handler does not ALSO AJAX-add the sample (that caused a double-add: 2 per
     click). After an add, update the header cart bubble directly. */
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('cart-count, .cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          if (c.item_count > 0) { el.hidden = false; el.removeAttribute('hidden'); }
        });
        ['cart:refresh', 'cart:change', 'cart:updated'].forEach(function (ev) {
          try { document.documentElement.dispatchEvent(new CustomEvent(ev, { bubbles: true, detail: c })); } catch (e) {}
        });
        return c;
      }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var buy = e.target.closest('a[data-kandes-buy-now]');
    if (buy) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (buy.getAttribute('data-busy')) return;
      buy.setAttribute('data-busy', '1');
      track('sample_buy_now_click', { product: buy.getAttribute('data-product-title') || '' });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(buy.getAttribute('data-kandes-buy-now')), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        window.location.href = '/checkout';
      }).catch(function () {
        window.location.href = buy.href;
      });
      return;
    }

    var add = e.target.closest('[data-kandes-add-sample]');
    if (add) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (add.getAttribute('data-busy')) return;
      add.setAttribute('data-busy', '1');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.getAttribute('data-kandes-add-sample')), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        track('sample_add_to_cart', { product: add.getAttribute('data-product-title') || '' });
        var scope = add.closest('[data-ksmp-scope]') || document;
        var note = scope.querySelector('[data-kandes-sample-note]');
        if (note) note.hidden = false;
        refreshCartCount();
      }).catch(function () {
        window.location.href = '/cart/' + add.getAttribute('data-kandes-add-sample') + ':1';
      }).finally(function () {
        add.removeAttribute('data-busy');
      });
      return;
    }

    var toggle = e.target.closest('[data-kandes-trade-toggle]');
    if (toggle) {
      var mini = document.getElementById(toggle.getAttribute('aria-controls'));
      if (mini) {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        mini.hidden = open;
      }
      return;
    }

    var tracked = e.target.closest('[data-ksmp-track]');
    if (tracked) {
      track(tracked.getAttribute('data-ksmp-track'), {
        product: tracked.getAttribute('data-product-title') || ''
      });
    }
  }, true);

  /* ---------- Trade verifier (Swiss CHE-UID + EU VAT) ---------- */
  function normNumber(v) { return String(v || '').toUpperCase().replace(/[\s.\-\/]/g, ''); }
  function isChe(v) { return /^CHE\d{9}(MWST|TVA|IVA|VAT)?$/.test(normNumber(v)); }
  function isEuVat(v) {
    var n = normNumber(v);
    if (/^CHE/.test(n)) return false;
    return /^(AT|BE|BG|CY|CZ|DE|DK|EE|EL|GR|ES|FI|FR|HR|HU|IE|IT|LT|LU|LV|MT|NL|PL|PT|RO|SE|SI|SK|XI)[0-9A-Z+*]{2,12}$/.test(n);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ksmp-trade]');
    if (!form) return;
    e.preventDefault();
    if (form.getAttribute('data-busy')) return;
    var MSG = i18n();
    var result = form.parentElement.querySelector('[data-ksmp-trade-result]');
    if (!result) return;
    var vat = (form.elements.vat && form.elements.vat.value || '').trim();
    var company = (form.elements.company && form.elements.company.value || '').trim();
    var email = (form.elements.email && form.elements.email.value || '').trim();
    var trap = (form.elements.kts_x1 && form.elements.kts_x1.value || '').trim();
    var consentEl = form.querySelector('input[name="consent"]');

    if (trap) { result.textContent = MSG.trade_pending || ''; return; }
    if (!vat || !email) { result.textContent = MSG.trade_fill || ''; return; }
    if (consentEl && !consentEl.checked) { form.reportValidity(); return; }
    if (!isChe(vat) && !isEuVat(vat)) { result.textContent = MSG.trade_recheck || ''; return; }

    var gateway = gatewayFor(form);
    if (!gateway) { result.textContent = MSG.trade_retry || ''; return; }

    var live = form.getAttribute('data-trade-live') === '1';
    var btn = form.querySelector('button[type="submit"]');
    var btnLabel = btn && btn.querySelector('.btn-text');
    var idle = btnLabel ? btnLabel.textContent : '';
    form.setAttribute('data-busy', '1');
    if (btn) btn.disabled = true;
    if (btnLabel) btnLabel.textContent = '…';

    function done() {
      form.removeAttribute('data-busy');
      if (btn) btn.disabled = false;
      if (btnLabel) btnLabel.textContent = idle;
    }

    if (!live) {
      /* Capture mode (default): a message-type lead on the live gateway.
         Works today — no worker change, no code reveal. Yulia verifies the
         number and replies with the trade code by email (draft-first rule). */
      fetch(gateway + '/lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          form_type: 'message',
          name: company,
          email: email,
          message: 'TRADE SAMPLE REQUEST (kandes.ch)\nVAT/UID: ' + vat +
                   '\nCompany: ' + company +
                   '\nPlease verify the number and reply with the trade sample code.',
          consent: true,
          locale: (document.documentElement.lang || 'en').split('-')[0],
          source_url: window.location.href.split('#')[0],
          website: trap
        })
      }).then(function (r) { return r.json(); }).then(function (b) {
        if (b && b.ok) {
          result.textContent = MSG.trade_pending || '';
          form.hidden = true;
          track('trade_sample_verify', { valid: 'pending', mode: 'capture', placement: form.getAttribute('data-ksmp-placement') || 'sample_panel' });
        } else {
          result.textContent = MSG.trade_retry || '';
        }
      }).catch(function () { result.textContent = MSG.trade_retry || ''; })
        .finally(done);
      return;
    }

    /* Live mode — only after the staged worker patch (CHE-UID + store-aware code)
       is deployed on Yulia's go AND the TRADESAMPLECH discount exists on .ch. */
    fetch(gateway + '/trade-sample', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, vat: vat, company: company, store: 'ch', source_url: window.location.href.split('#')[0] })
    }).then(function (r) { return r.json().then(function (b) { return { status: r.status, body: b }; }); })
      .then(function (res) {
        var b = res.body || {};
        if (b.ok && b.valid === true) {
          var who = b.company ? ' (' + b.company + ')' : '';
          result.innerHTML = '';
          var p1 = document.createElement('p'); p1.style.margin = '0'; p1.textContent = (MSG.trade_success || '') + who;
          var code = document.createElement('span'); code.className = 'kpt-trade__code'; code.textContent = 'TRADESAMPLECH';
          var p2 = document.createElement('p'); p2.style.margin = '6px 0 0'; p2.textContent = 'Enter this code at checkout — your samples and their shipping come with our compliments.';
          result.appendChild(p1); result.appendChild(code); result.appendChild(p2);
          track('trade_sample_verify', { valid: true, mode: 'live', placement: form.getAttribute('data-ksmp-placement') || 'sample_panel' });
        } else if (b.ok && b.valid === false) {
          result.textContent = MSG.trade_recheck || '';
          track('trade_sample_verify', { valid: false, mode: 'live', placement: form.getAttribute('data-ksmp-placement') || 'sample_panel' });
        } else if (b.ok) {
          result.textContent = MSG.trade_pending || '';
        } else {
          result.textContent = MSG.trade_retry || '';
        }
      })
      .catch(function () { result.textContent = MSG.trade_retry || ''; })
      .finally(done);
  });
})();
